import Space from 'Modules/Space';
import InfoIcon from 'Assets/images/commons/warning.svg';
import { getMedicineRequest } from 'Redux/modules/marketplace/actions';
import { func, number } from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider, Message, MessageContent, Modal, Segment } from 'semantic-ui-react';
import moment from 'moment';

import styles from './ModalMedicineRequest.less';

import MarketplaceItem from '@/components/MarketplaceItem';
import PriceSummary from '@/components/PriceSummary';

const ModalMedicineRequest = props => {
  const dispatch = useDispatch();
  const { data, close } = props;
  const { id, title } = data;

  const marketplace = useSelector(state => state.marketplace);
  const { medicineRequestDetail, status } = marketplace;

  const { order, expiresAt } = medicineRequestDetail ?? {};
  const { totalPrice, subtotalPrice, loyaltyAmount, discount } = order ?? {};

  useEffect(() => {
    dispatch(getMedicineRequest(id));
  }, [dispatch, id]);

  return (
    <Modal open closeIcon onClose={close} closeOnDimmerClick style={{ width: 640 }}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content style={{ fontSize: 16 }}>
        <Segment
          basic
          loading={status.medicineRequestDetail === 0}
          style={{ minHeight: 100, padding: 0 }}>
          <Space size={12}>
            {medicineRequestDetail?.status === 'approved' && expiresAt && (
              <Message icon className={styles.alert}>
                <Space direction="horizontal" alignItems="center" size={12}>
                  <img src={InfoIcon} alt="" />
                  <MessageContent>
                    {`Available to order till ${moment(expiresAt).format('MMM DD, YYYY HH:mm')}`}
                  </MessageContent>
                </Space>
              </Message>
            )}
            <Space width="100%" size={4}>
              {medicineRequestDetail?.medicineRequestProducts?.map((e, i) => (
                <>
                  {i !== 0 && <Divider />}
                  <MarketplaceItem key={e.id} product={e.product} quantity={e.quantity} />
                </>
              ))}
            </Space>
            {order && (
              <PriceSummary
                total={totalPrice}
                subTotal={subtotalPrice}
                discount={discount}
                loyaltyAmount={loyaltyAmount}
              />
            )}
          </Space>
        </Segment>
      </Modal.Content>
    </Modal>
  );
};

ModalMedicineRequest.propTypes = {
  data: number.isRequired,
  close: func.isRequired,
};

ModalMedicineRequest.defaultProps = {};

export default ModalMedicineRequest;
